
import { ProfessionData } from '../types/professionTypes';

export const peintre: ProfessionData = {
  title: "Peintre",
  slug: "peintre",
  description: "Solutions spécialisées pour les déchets de peinture",
  icon: "Paintbrush",
  heroImage: "/lovable-uploads/328f4f86-9058-4b88-b6b8-5bcc727eb914.png",
  wasteMaterials: [
    {
      type: "Pots de peinture",
      description: "Pots vides ou contenant des résidus de peintures diverses.",
      solutions: ["Collecte spécifique", "Traitement séparé"],
      environmentalBenefit: "Valorisation contenants et neutralisation résidus"
    },
    {
      type: "Solvants et diluants",
      description: "Produits chimiques utilisés pour diluer ou nettoyer en peinture.",
      solutions: ["Contenants sécurisés", "Régénération"],
      environmentalBenefit: "Réutilisation possible après purification"
    },
    {
      type: "Matériel souillé",
      description: "Bâches, rouleaux, pinceaux et autres équipements imprégnés.",
      solutions: ["Collecte en sacs spéciaux", "Incinération contrôlée"],
      environmentalBenefit: "Valorisation énergétique sécurisée"
    }
  ],
  relatedProfessions: ["platrier", "carreleur", "decorateur"]
};
